import Carousel from "react-bootstrap/Carousel";
import eveningImage from "../images/evening.png";
import bellImage from "../images/bell.jpeg";
import bluedomeImage from "../images/bluedome.jpeg";

function CarouselGallery() {
	return (
		<div style={{ display: "flex", justifyContent: "center" }}>
			<Carousel fade>
				<Carousel.Item>
					<img
						className="d-block w-100"
						src="https://images.hellomagazine.com/horizon/landscape/9e37dc0a1790-greece-t.jpg"
						alt="First slide"
					/>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className="d-block w-100 "
						src="https://traveler.marriott.com/wp-content/uploads/2019/02/Santorini-Greece.jpg"
						alt="Second slide"
					/>
				</Carousel.Item>

				<Carousel.Item>
					<img
						className="d-block w-100"
						src={eveningImage}
						alt="Second slide"
					/>
				</Carousel.Item>

				<Carousel.Item>
					<img
						className="d-block w-100"
						src={bellImage}
						alt="Second slide"
					/>
				</Carousel.Item>

				<Carousel.Item>
					<img
						className="d-block w-100"
						src={bluedomeImage}
						alt="Second slide"
					/>
				</Carousel.Item>
			</Carousel>
		</div>
	);
}

export default CarouselGallery;
